import React, { useState } from 'react';
import { useTheme } from '../context/ThemeContext';
import { useAuth } from '../context/AuthContext';
import { useCompany } from '../context/CompanyContext';
import { api } from '../services/api';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import './Settings.css';

const TABS = ['Profile','Company','Security','Billing'];

export default function Settings() {
  const { theme }  = useTheme();
  const { user, logout } = useAuth();
  const { company, update } = useCompany();
  const [tab,    setTab]    = useState('Profile');
  const [co,     setCo]     = useState(company);
  const [saved,  setSaved]  = useState(false);
  const [curPass, setCurPass] = useState('');
  const [newPass, setNewPass] = useState('');
  const [confPass, setConfPass] = useState('');
  const [passMsg, setPassMsg] = useState('');
  const [passErr, setPassErr] = useState('');
  const setCof = (k,v) => setCo(p=>({...p,[k]:v}));

  const saveCompany = async () => {
    try {
      await api.saveCompany(co);
      update(co);
      setSaved(true);
      setTimeout(()=>setSaved(false),2000);
    } catch(e) { alert(e.message); }
  };

  const changePassword = async () => {
    setPassErr(''); setPassMsg('');
    if (newPass !== confPass) return setPassErr('Passwords do not match');
    if (newPass.length < 8) return setPassErr('Password must be at least 8 characters');
    try {
      await api.changePassword(curPass, newPass);
      setPassMsg('Password updated successfully');
      setCurPass(''); setNewPass(''); setConfPass('');
    } catch(e) { setPassErr(e.message); }
  };

  return (
    <div className="st-wrap" data-theme={theme}>
      <Sidebar/>
      <div className="st-main">
        <Topbar title="Settings" subtitle="Manage your account and workspace"/>
        <div className="st-body">
          <div className="st-nav">
            {TABS.map(t=><div key={t} className={`st-nav-item${tab===t?' active':''}`} onClick={()=>setTab(t)}>{t}</div>)}
          </div>
          <div className="st-content">
            {tab==='Profile' && (
              <div className="st-section">
                <div className="st-sec-title">My Profile</div>
                <div className="st-av-row">
                  <div className="st-av">{user.initials}</div>
                  <div>
                    <div className="st-av-name">{user.name}</div>
                    <div className="st-av-email">{user.email}</div>
                    <div className="st-av-role" style={{color: user.role==='Super Admin'?'#F5A623':user.role==='Admin'?'#3B82F6':'#22C55E'}}>{user.role}</div>
                  </div>
                </div>
                <div className="st-info-note">To update your name, email or phone, ask your Super Admin to edit your profile in Team Management.</div>
              </div>
            )}
            {tab==='Company' && (
              <div className="st-section">
                <div className="st-sec-title">Company Profile</div>
                <div className="st-company-note">This information appears on your invoices and throughout RyzenOS.</div>
                <div className="st-fields">
                  {[
                    {k:'name',    label:'Company name',   placeholder:'Ryzenforge Enterprises LLP'},
                    {k:'tagline', label:'Tagline',         placeholder:'Run your business smarter'},
                    {k:'email',   label:'Business email',  placeholder:'hello@company.in'},
                    {k:'phone',   label:'Phone',           placeholder:'+91 XXXXX XXXXX'},
                    {k:'website', label:'Website',         placeholder:'www.company.in'},
                    {k:'gstin',   label:'GSTIN',           placeholder:'22AAAAA0000A1Z5'},
                    {k:'address', label:'Address',         placeholder:'Street, Building'},
                    {k:'city',    label:'City',            placeholder:'Kochi'},
                    {k:'state',   label:'State',           placeholder:'Kerala'},
                    {k:'pincode', label:'Pincode',         placeholder:'682017'},
                  ].map(f=>(
                    <div key={f.k} className="st-field-grp">
                      <label className="st-lbl">{f.label}</label>
                      <input className="st-inp" placeholder={f.placeholder} value={co[f.k]||''} onChange={e=>setCof(f.k,e.target.value)}/>
                    </div>
                  ))}
                </div>
                <div className="st-save-row">
                  <div className="st-save-btn" onClick={saveCompany}>{saved?'✓ Saved':'Save company profile'}</div>
                </div>
              </div>
            )}
            {tab==='Security' && (
              <div className="st-section">
                <div className="st-sec-title">Change Password</div>
                {passErr && <div className="st-err">{passErr}</div>}
                {passMsg && <div className="st-succ">{passMsg}</div>}
                <div className="st-fields">
                  <div className="st-field-grp"><label className="st-lbl">Current password</label><input className="st-inp" type="password" placeholder="••••••••" value={curPass} onChange={e=>setCurPass(e.target.value)}/></div>
                  <div className="st-field-grp"><label className="st-lbl">New password</label><input className="st-inp" type="password" placeholder="Min 8 characters" value={newPass} onChange={e=>setNewPass(e.target.value)}/></div>
                  <div className="st-field-grp"><label className="st-lbl">Confirm new password</label><input className="st-inp" type="password" placeholder="••••••••" value={confPass} onChange={e=>setConfPass(e.target.value)}/></div>
                </div>
                <div className="st-save-row"><div className="st-save-btn" onClick={changePassword}>Update password</div></div>
              </div>
            )}
            {tab==='Billing' && (
              <div className="st-section">
                <div className="st-sec-title">Billing</div>
                <div className="st-billing-card">
                  <div className="st-plan-name">RyzenOS Pro</div>
                  <div className="st-plan-price">₹7,499 <span>/month</span></div>
                  <div className="st-plan-status">✓ Active — Next billing 26 June 2026</div>
                </div>
                <div className="st-billing-info">
                  {[{label:'Plan',val:'Pro — Unlimited leads, team, finance'},{label:'Users',val:'Up to 25 team members'},{label:'Storage',val:'50 GB'},{label:'Support',val:'Priority support'}].map(r=>(
                    <div key={r.label} className="st-info-row"><span className="st-info-lbl">{r.label}</span><span className="st-info-val">{r.val}</span></div>
                  ))}
                </div>
                <div className="st-billing-note">To make changes to your subscription, contact support at connect@ryzenforge.com</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
